/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'down': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(11 15)" _stroke="#00272E"><polyline pid="0" points="10 0 5 4 0 0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/down.js